var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickApplySuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5810_17626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.75 52.5C68.2475 52.5 80 40.7475 80 26.25C80 11.7525 68.2475 0 53.75 0C39.2525 0 27.5 11.7525 27.5 26.25C27.5 40.7475 39.2525 52.5 53.75 52.5Z",
    fill: "#36BF29",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 33.75H18.75V43.75L8.75 33.75H1.25V1.25H48.75V33.75H45",
    stroke: "#222829",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 48.75H1.25V78.75H20V48.75Z",
    stroke: "#222829",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 76.25L28.75 78.75H50C52.07 78.75 53.75 77.07 53.75 75C53.75 72.93 52.07 71.25 50 71.25H51.25C53.32 71.25 55 69.57 55 67.5C55 65.43 53.32 63.75 51.25 63.75H53.75C55.82 63.75 57.5 62.07 57.5 60C57.5 57.93 55.82 56.25 53.75 56.25H52.5C54.57 56.25 56.25 54.57 56.25 52.5C56.25 50.43 54.57 48.75 52.5 48.75H36.25L41.25 35V32.5C41.25 30.43 39.57 28.75 37.5 28.75C35.43 28.75 33.75 30.43 33.75 32.5L30 40L22.5 48.75H20",
    stroke: "#222829",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 72.5V75",
    stroke: "#222829",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 11.25H78.75V41.25H71.25L61.25 51.25V41.25H45",
    stroke: "#222829",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 17.5H21.25",
    stroke: "#36BF29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 17.5H26.25",
    stroke: "#36BF29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 17.5H31.25",
    stroke: "#36BF29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 18.75H52.5",
    stroke: "#36BF29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 26.25H52.5",
    stroke: "#36BF29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 33.75H52.5",
    stroke: "#36BF29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 11.25H8.75V23.75H41.25V11.25Z",
    stroke: "#36BF29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5810_17626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickApplySuccessIcon);
export default __webpack_public_path__ + "static/media/quick-apply-success-icon.c3119032cb424b4b770bac67e22cbc33.svg";
export { ForwardRef as ReactComponent };